import gql from 'graphql-tag';

const GET_AI_RECOMMENDED_SOLUTIONS = gql`
  query getAIRecommendedSolutions($ticketId: ID!) {
    getAIRecommendedSolutions(ticketId: $ticketId) {
      title
      summary
      tickets {
        ticketId
        displayId
        subject
        clientName
      }
    }
  }
`;

const GET_AI_RECOMMENDED_SOLUTIONS_V2 = gql`
  query getAIRecommendedSolutionsV2($ticketId: ID!) {
    getAIRecommendedSolutionsV2(ticketId: $ticketId) {
      title
      summary
      tickets {
        ticketId
        displayId
        subject
        clientName
      }
      kbArticles {
        id
        title
        userType
        visibilityType
        loginRequired
      }
    }
  }
`;

const GET_AI_RECOMMENDED_SOLUTION_REPLY = gql`
  query getAIRecommendedSolutionReply(
    $ticketId: ID!
    $recommendedSolutionTicketIds: [ID!]!
    $recommendedSolution: String!
  ) {
    getAIRecommendedSolutionReply(
      ticketId: $ticketId
      recommendedSolutionTicketIds: $recommendedSolutionTicketIds
      recommendedSolution: $recommendedSolution
    )
  }
`;

const GET_AI_RECOMMENDED_SOLUTION_REPLY_V2 = gql`
  query getAIRecommendedSolutionReplyV2(
    $ticketId: ID!
    $recommendedSolutionTicketIds: [ID!]!
    $recommendedSolution: String!
    $recommendedSolutionKBArticles: [AIRecommendationKBArticleInput]
  ) {
    getAIRecommendedSolutionReplyV2(
      ticketId: $ticketId
      recommendedSolutionTicketIds: $recommendedSolutionTicketIds
      recommendedSolution: $recommendedSolution
      recommendedSolutionKBArticles: $recommendedSolutionKBArticles
    ) {
      recommendedReply
      recommendedSolutionArticles {
        id
        title
        userType
        visibilityType
        loginRequired
      }
    }
  }
`;

const GET_AI_SUGGESTED_PROPERTIES = gql`
  query getAISuggestedProperties(
    $ticketId: ID!
    $recommendedSolutionTicketIds: [ID!]!
  ) {
    getAISuggestedProperties(
      ticketId: $ticketId
      recommendedSolutionTicketIds: $recommendedSolutionTicketIds
    ) {
      defaultProperties {
        name
        label
        value
      }
      additionalProperties {
        name
        label
        value
      }
    }
  }
`;

const GET_AI_WEB_SEARCH_TERMS = gql`
  query getAIWebSearchTerms($ticketId: ID!) {
    getAIWebSearchTerms(ticketId: $ticketId) {
      searchTerm
      searchTermId
    }
  }
`;

const GET_AI_WEB_SEARCH_RECOMMENDATION = gql`
  query getAIWebSearchRecommendation(
    $searchTerm: String!
    $searchTermId: String!
  ) {
    getAIWebSearchRecommendation(
      searchTerm: $searchTerm
      searchTermId: $searchTermId
    )
  }
`;

const GET_AI_WEB_SEARCH_RECOMMENDATION_REPLY = gql`
  query getAIWebSearchRecommendationReply(
    $ticketId: ID!
    $recommendation: String!
  ) {
    getAIWebSearchRecommendationReply(
      ticketId: $ticketId
      recommendation: $recommendation
    )
  }
`;

const GET_AI_RECOMMENDED_TICKET_SUMMARIES = gql`
  query getAIRecommendedTicketSummaries(
    $ticketId: ID!
    $recommendedSolutionTicketIds: [ID!]!
    $recommendedSolution: String!
  ) {
    getAIRecommendedTicketSummaries(
      ticketId: $ticketId
      recommendedSolutionTicketIds: $recommendedSolutionTicketIds
      recommendedSolution: $recommendedSolution
    ) {
      ticketId
      summary
      displayId
      subject
      clientName
    }
  }
`;

export {
  GET_AI_RECOMMENDED_SOLUTIONS,
  GET_AI_RECOMMENDED_SOLUTIONS_V2,
  GET_AI_RECOMMENDED_SOLUTION_REPLY,
  GET_AI_RECOMMENDED_SOLUTION_REPLY_V2,
  GET_AI_WEB_SEARCH_RECOMMENDATION,
  GET_AI_SUGGESTED_PROPERTIES,
  GET_AI_WEB_SEARCH_TERMS,
  GET_AI_WEB_SEARCH_RECOMMENDATION_REPLY,
  GET_AI_RECOMMENDED_TICKET_SUMMARIES
};
